import Page from "webPage/Page";
import ScrollMagic from "scrollmagic";
import {TimelineMax, TweenMax} from "gsap";
import {createController, registerScene, sectionGetHeight} from "../util/parallax";

Page.register('single-recruitment', () => {
    createController();

    registerScene(new ScrollMagic.Scene({
        triggerElement: '.section--resources-article',
        duration:       sectionGetHeight('.section--resources-article'),
        triggerHook:    "onEnter",
    }).setTween(new TimelineMax().add([
        TweenMax.fromTo('.js-circle-yellow-1', 1, {y: 500}, {y: -500, ease: Power0.easeNone}),
        TweenMax.fromTo('.js-circle-blue-1', 1, {y: -500}, {y: 0, ease: Power0.easeNone}),
        TweenMax.fromTo('.js-circle-orange-1', 1, {y: -500}, {y: 50, ease: Power0.easeNone}),
    ])));

    $('body').on('click', '.js-apply', function () {
        $('body').addClass('modal-active');
        $('.js-apply-modal').addClass('modal--active');

        return false;
    }).on('click', '.js-close-modal', function () {
        $('body').removeClass('modal-active');
        $('.js-apply-modal').removeClass('modal--active');
    });
});
